import { render, staticRenderFns } from "./Insure.vue?vue&type=template&id=f70c9b22&"
import script from "./Insure.vue?vue&type=script&lang=js&"
export * from "./Insure.vue?vue&type=script&lang=js&"
import style0 from "./Insure.vue?vue&type=style&index=0&id=f70c9b22&prod&lang=css&"
import style1 from "./Insure.vue?vue&type=style&index=1&id=f70c9b22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports